// import { useEffect, useState } from 'react';
// import Layout from '../layout/Layout';
// import StatsCards from '../components/StatsCards';
// import UsageChart from '../components/UsageChart';
// import PageTransition from '../components/PageTransition';
// import { NavLink } from 'react-router-dom';
// import { getUserStats } from '../components/DbServices';


// export default function Dashboard() {
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const user = getStoredUser();
//   const userName = user?.data?.name || 'User';
//   const userId = user?.data?.id;

//   useEffect(() => {
//     const loadDashboardData = async () => {
//       if (!userId) return;
//       const res = await getUserStats(userId);
//       if (res && res.status === 200) {
//         setStats(res.data);
//         localStorage.setItem('subscription_id',res.data.subscription_id)
//       }
//       setLoading(false);
//     };

//     loadDashboardData();
//   }, [userId]);

//   return (
//     <Layout>
//       <PageTransition>
//         {/* HEADER SECTION */}
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <div>
//             <h3 className="fw-bold mb-1">Welcome back, {userName}! 👋</h3>
//             <p className="text-muted small">Here is what's happening with your WhatsApp API today.</p>
//           </div>
//           <div className="d-flex gap-2">
//             <NavLink to="/devices" className="btn btn-primary shadow-sm d-flex align-items-center gap-2 rounded-3">
//               <i className="fas fa-plus"></i> Add Device
//             </NavLink>
//             <NavLink to="/apps" className="btn btn-light border shadow-sm d-flex align-items-center gap-2 rounded-3">
//               <i className="fas fa-code"></i> My Apps
//             </NavLink>
//           </div>
//         </div>

//         {/* STATS SECTION - We pass the stats down to avoid double API calls */}
//         <StatsCards externalStats={stats} loading={loading} />

//         <div className="row mt-4">
//           {/* MAIN CHART SECTION */}
//           <div className="col-lg-8 mb-4">
//             <div className="card border-0 shadow-sm rounded-4 h-100">
//               <div className="card-body p-4">
//                 <div className="d-flex justify-content-between align-items-center mb-4">
//                   <div>
//                     <h5 className="fw-bold mb-0">Message Activity</h5>
//                     <small className="text-muted">Traffic overview for the last 7 days</small>
//                   </div>
//                   <i className="fas fa-chart-line text-muted"></i>
//                 </div>

//                 {loading ? (
//                   <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
//                     <div className="spinner-border text-primary opacity-25"></div>
//                   </div>
//                 ) : (
//                   <UsageChart chartData={stats?.weekly_traffic} />
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* QUICK ACTIONS */}
//           <div className="col-lg-4 mb-4">
//             <div className="card border-0 shadow-sm rounded-4 h-100 overflow-hidden">
//               <div className="card-header bg-white border-0 pt-4 px-4 pb-0">
//                 <h5 className="fw-bold mb-0">Quick Actions</h5>
//                 <p className="text-muted small">Frequent tasks and resources</p>
//               </div>
//               <div className="card-body px-4">
//                 <div className="d-flex flex-column gap-2">
//                   <ShortcutItem
//                     icon="fas fa-file-csv"
//                     label="Export Report"
//                     description="Download monthly usage"
//                     color="bg-primary-subtle text-primary"
//                     to="/reports"
//                   />
//                   <ShortcutItem
//                     icon="fas fa-key"
//                     label="Manage API Keys"
//                     description="View or rotate keys"
//                     color="bg-info-subtle text-info"
//                     to="/apps"
//                   />
//                   <ShortcutItem
//                     icon="fas fa-terminal"
//                     label="API Sandbox"
//                     description="Test your endpoints"
//                     color="bg-dark-subtle text-dark"
//                     to="/sandbox"
//                   />
//                   <ShortcutItem
//                     icon="fas fa-question-circle"
//                     label="Help Center"
//                     description="Guides & Documentation"
//                     color="bg-success-subtle text-success"
//                     to="/docs"
//                   />
//                 </div>

//                 {/* Dynamic Upgrade Banner */}
//                 <div className="mt-4 p-3 rounded-4 position-relative overflow-hidden"
//                   style={{ background: 'linear-gradient(45deg, #4C1D95, #7C3AED)' }}>
//                   <div className="position-relative z-index-1">
//                     <p className="text-white small mb-2 opacity-75">Need more power?</p>
//                     <h6 className="text-white fw-bold mb-3">Upgrade to Enterprise</h6>
//                     <NavLink to="/pricing" className="btn btn-sm btn-white w-100 rounded-3 fw-bold shadow-sm"
//                       style={{ backgroundColor: '#fff', color: '#4C1D95' }}>
//                       View Plans
//                     </NavLink>
//                   </div>
//                   {/* Subtle background decoration */}
//                   <i className="fas fa-rocket position-absolute text-white opacity-10"
//                     style={{ fontSize: '4rem', bottom: '-10px', right: '-10px', transform: 'rotate(-20deg)' }}></i>
//                 </div>
//               </div>
//             </div>



//           </div>
//         </div>
//       </PageTransition>
//     </Layout>
//   );
// }

// function ShortcutItem({ icon, label, description, color, to }) {
//   return (
//     <NavLink
//       to={to}
//       className="text-decoration-none d-flex align-items-center p-3 rounded-3 transition-all shortcut-hover"
//       style={{ border: '1px solid #f1f1f1' }}
//     >
//       <div className={`rounded-3 d-flex align-items-center justify-content-center me-3 ${color}`}
//         style={{ width: '48px', height: '48px', flexShrink: 0 }}>
//         <i className={`${icon} fa-lg`}></i>
//       </div>
//       <div className="flex-grow-1">
//         <div className="fw-bold text-dark small mb-0">{label}</div>
//         <div className="text-muted" style={{ fontSize: '0.75rem' }}>{description}</div>
//       </div>
//       <i className="fas fa-chevron-right text-muted opacity-50 small"></i>
//     </NavLink>
//   );
// }

import { useEffect, useState } from 'react';
import Layout from '../layout/Layout';
import StatsCards from '../components/StatsCards';
import UsageChart from '../components/UsageChart';
import PageTransition from '../components/PageTransition';
import { NavLink } from 'react-router-dom';
import { getUserStats } from '../components/DbServices';
import { getStoredUser } from '../utilities/encryption';
import Swal from 'sweetalert2';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const user = getStoredUser();
  
  const userName = user?.data?.name || 'User';
  const userId = user?.data?.id;

  useEffect(() => {
    const loadDashboardData = async () => {
      if (!userId) return;
      const res = await getUserStats(userId);
      if (res && res.status === 200) {
        
        setStats(res.data);
        localStorage.setItem('subscription_id', res.data.subscription_id);
      }
      setLoading(false);
    };
    loadDashboardData();
  }, [userId]);

  return (
    <Layout>
      <PageTransition>
        {/* HERO GREETING SECTION */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm overflow-hidden position-relative" 
                 style={{ 
                   background: 'linear-gradient(135deg, #fdfcfb 0%, #e2d1c3 100%)',
                   borderRadius: '24px' 
                 }}>
              <div className="card-body p-4 p-md-5 position-relative z-index-1">
                <div className="row align-items-center">
                  <div className="col-md-8">
                    <span className="badge bg-primary bg-opacity-10 text-white px-3 py-2 rounded-pill mb-3 fw-bold">
                      <i className="fas fa-sparkles me-2"></i> System Online
                    </span>
                    <h1 className="display-6 fw-bold mb-2">
                      Welcome back, <span className="color-theme">{userName}</span>!
                    </h1>
                    <p className="text-muted lead mb-4" style={{ fontSize: '1.1rem' }}>
                      Everything is running smoothly. You have sent <b>{stats?.messages_sent || 0}</b> messages this month.
                    </p>
                    <div className="d-flex gap-3">
                      <NavLink to="/devices" className="btn btn-primary rounded-pill px-4 py-2 fw-bold shadow">
                        <i className="fas fa-plus-circle me-2"></i> New Instance
                      </NavLink>
                      <NavLink to="/apps" className="btn btn-outline-dark rounded-pill px-4 py-2 fw-bold">
                        Documentation
                      </NavLink>
                    </div>
                  </div>
                  <div className="col-md-4 d-none d-md-block text-center">
                    <i className="fab fa-whatsapp text-success opacity-25" style={{ fontSize: '10rem' }}></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* STATS SECTION */}
        <div className="mb-4">
          <StatsCards externalStats={stats} loading={loading} />
        </div>

        <div className="row g-4">
          {/* INTERACTIVE CHART CARD */}
          <div className="col-lg-8">
            <div className="card border-0 shadow-sm h-100" style={{ borderRadius: '24px' }}>
              <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h5 className="fw-bold mb-1">Performance Analytics</h5>
                    <p className="text-muted x-small mb-0">Live outbound traffic visualization</p>
                  </div>
                  <div className="bg-primary bg-opacity-10 p-2 rounded-3">
                    <i className="fas fa-wave-square text-primary"></i>
                  </div>
                </div>
                <div style={{ height: '350px' }}>
                  {loading ? (
                    <div className="h-100 d-flex justify-content-center align-items-center">
                      <div className="spinner-grow text-primary"></div>
                    </div>
                  ) : (
                    <UsageChart chartData={stats?.weekly_traffic} />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* COLORFUL SIDEBAR */}
          <div className="col-lg-4">
            <div className="row g-4">
                {/* INTEGRATION PROMO CARD */}
                <div className="col-12">
                <div className="card border-0 shadow text-white h-100 position-relative overflow-hidden" 
                     style={{ 
                       background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)',
                       borderRadius: '24px' 
                     }}>
                  <div className="card-body p-4 position-relative z-index-1">
                    <h6 className="fw-bold">Developer API</h6>
                    <p className="x-small opacity-75">Integrate WhatsApp into your own CRM or App in minutes.</p>
                    <hr className="opacity-25" />
                    <div className="d-flex align-items-center gap-2 mb-3">
                       <span className="badge bg-white bg-opacity-25 text-white">PHP</span>
                       <span className="badge bg-white bg-opacity-25 text-white">Node.js</span>
                       <span className="badge bg-white bg-opacity-25 text-white">Python</span>
                    </div>
                    <NavLink to="/apps" className="btn btn-light btn-sm w-100 rounded-pill fw-bold">
                      Get API Key
                    </NavLink>
                  </div>
                  <i className="fas fa-code position-absolute bottom-0 end-0 m-n3 opacity-10" style={{ fontSize: '8rem' }}></i>
                </div>
              </div>
              {/* QUICK TOOLS CARD */}
              <div className="col-12">
                <div className="card border-0 shadow-sm p-4" style={{ borderRadius: '24px' }}>
                  <h6 className="fw-bold mb-4">Master Toolbox</h6>
                  <div className="d-grid gap-3">
                    <GlassToolItem color="#6366f1" icon="fa-bolt" label="API Sandbox" to="/sandbox" />
                    <GlassToolItem color="#10b981" icon="fa-file-invoice" label="Billing Info" to="/pricing" />
                    <GlassToolItem color="#f59e0b" icon="fa-shield-alt" label="Settings" to="/settings" />
                    <GlassToolItem color="#ec4899" icon="fa-life-ring" label="Docs" to="/docs" />
                  </div>
                </div>
              </div>

            
            </div>
          </div>
        </div>
      </PageTransition>
    </Layout>
  );
}

function GlassToolItem({ color, icon, label, to }) {
  return (
    <NavLink to={to} className="text-decoration-none d-flex align-items-center p-3 rounded-4 bg-light bg-opacity-50 border border-white transition-all tool-card">
      <div className="rounded-circle d-flex align-items-center justify-content-center me-3" 
           style={{ backgroundColor: color, width: '40px', height: '40px', boxShadow: `0 4px 10px ${color}44` }}>
        <i className={`fas ${icon} text-white small`}></i>
      </div>
      <span className="fw-bold text-dark small">{label}</span>
      <i className="fas fa-chevron-right ms-auto x-small text-muted"></i>
    </NavLink>
  );
}